export default __webpack_public_path__ + "assets/images/arrow-up.a1ed0694f323d7106c8e03af0b2f117e.png";